import {FC} from 'react'

type Props = {
  two_steps?: boolean
}

const ExtraTwoStepsCell: FC<Props> = ({two_steps}) => (
  <> {two_steps && <div className='badge badge-success fs-4 fw-bolder'>Active</div>}</>
)

export {ExtraTwoStepsCell}
